<template>
  <b-form-input
    @input="onInput"
    @keyup="onKeyup"
    @keypress.native="onKeypress"
    @paste.prevent
    :value="value"
    :maxlength="maxLength"
    :placeholder="placeholder"
    :class="className"
    :disabled="disabled"
    inputmode="numeric"
    pattern="[0-9]*"
  />
</template>

<script>
export default {
  props: ["value", "maxLength", "placeholder", "className", "disabled"],
  methods: {
    onKeyup(e) {
      if (/^\d*$/.test(String.fromCharCode(e.keyCode))) this.$emit("keyup", e);
    },
    onKeypress(e) {
      if (/[^0-9]/g.test(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    onInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>